<template>
  <div id="app">
    <el-container v-if="isIntegratedEntrance">
      <router-view />
    </el-container>
    <el-container v-else>
      <el-header style="padding: 0">
        <navigationTop />
      </el-header>
      <el-main>
        <router-view />
        <navigationButtom />
      </el-main>
      <!--      固定在整个页面-->
      <fixedPosition />
    </el-container>
  </div>
</template>

<script>
import navigationTop from '@/components/navigationTop'
import navigationButtom from '@/components/navigationButtom'
import fixedPosition from '@/components/fixedPosition'
export default {
  name: 'App',
  components: {
    navigationTop,
    navigationButtom,
    fixedPosition
  },
  data() {
    return {
    }
  },
  computed: {
    isIntegratedEntrance() {
      return this.$route.path.startsWith('/IntegratedEntrance')
    }
  },
  watch: {
    '$route': {
      handler() {
        // 路由切换时强制滚动到顶部
        this.scrollToTop()
      },
      immediate: true
    }
  },
  created() {
    // 页面加载时也滚动到顶部
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      // 立即执行滚动
      window.scrollTo(0, 0)

      // Vue nextTick确保DOM更新
      this.$nextTick(() => {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0

        // 检查并滚动所有可能的滚动容器
        const containers = [
          document.querySelector('.el-main'),
          document.querySelector('.el-container'),
          document.getElementById('app'),
          document.querySelector('[overflow-y]'),
          document.querySelector('[style*="overflow-y"]')
        ]

        containers.forEach(container => {
          if (container && typeof container.scrollTop !== 'undefined') {
            container.scrollTop = 0
          }
        })
      })

      // 再次确保滚动（处理异步情况）
      setTimeout(() => {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 100)
    }
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100%;
}
.el-container {
  min-height: 100%;
}
.el-header {
  padding: 0;
}
</style>
